module.exports = __webpack_public_path__ + "img/map.51035aa3.png";